import { render, staticRenderFns } from "./SearchAutocomplete.vue?vue&type=template&id=f541702e"
import script from "./SearchAutocomplete.vue?vue&type=script&lang=js"
export * from "./SearchAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./SearchAutocomplete.vue?vue&type=style&index=0&id=f541702e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports